import type { Keyframes } from '../components/AnimatedWrapper/AnimatedWrapper';

/**
 * Merges multiple motion primitive keyframe objects into a single `Keyframes`
 * object that can be passed to `AnimatedWrapper` or `TransitionWrapper`.
 *
 * Matching percentage keys (e.g. `"0%"`, `"100%"`) are shallow-merged so that
 * each primitive's CSS properties are combined into one frame.
 *
 * @example
 * ```ts
 * import { combineKeyframes, slideInLeft, fadeIn } from '@americanexpress/dls-motion';
 *
 * <AnimatedWrapper animation={combineKeyframes(slideInLeft, fadeIn)} />
 * ```
 */
export function combineKeyframes(...keyframeSets: Keyframes[]): Keyframes {
  const merged: Keyframes = {};

  for (const keyframes of keyframeSets) {
    for (const [percent, styles] of Object.entries(keyframes)) {
      merged[percent] = { ...merged[percent], ...styles };
    }
  }

  return merged;
}
